import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import FontSizeToggle from "../components/FontSizeToggle";

const sanitize = (html) => DOMPurify.sanitize(html || "", {
  ADD_ATTR: ["target", "rel", "class", "style"],
  ALLOW_DATA_ATTR: false,
});

const Datenschutz = () => {
  const [s, setS] = useState(null);
  const [size, setSize] = useState(15);
  useEffect(() => { (async () => setS(await api.getSettings()))(); }, []);
  if (!s) return <div className="flex items-center justify-center py-24 text-zinc-400"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  return (
    <section className="mx-auto max-w-3xl px-4 py-12" data-testid="datenschutz-page">
      <div className="rounded-2xl border border-white/10 bg-[#0f141b] px-6 py-8 md:px-10 md:py-10 overflow-hidden">
        <FontSizeToggle
          storageKey="habthek-static-font-size"
          initial={15}
          onChange={setSize}
          data-testid="datenschutz-font-size"
          className="mb-4"
        />
        <div
          className="news-content"
          style={{ "--news-font-size": `${size}px` }}
          dangerouslySetInnerHTML={{ __html: sanitize(s.datenschutz_html) }}
        />
      </div>
    </section>
  );
};

export default Datenschutz;
